import * as React from 'react';

const FullStarSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={32} height={32} fill="none" {...props}>
        <path
            d="M16 5.333l4.079 6.546 7.92 1.603-5.4 5.648.817 7.537L16 23.612l-7.417 3.055.817-7.537L4 13.482l7.92-1.603L16 5.333z"
            fill="#D1410C"
        />
    </svg>
);

FullStarSvg.displayName = 'FullStarSvg';
export default FullStarSvg;
